module.exports = require("@workbench-stack/components/lib/editors");